import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { setDrawerOpenState } from '../redux/actions/drawerActions';
import { useAppDispatch } from '../redux/store';
import { HEADER_SUBTITLE_COLOR } from '../styles/colors';
const CONTAINER_CSS = css `
  flex-grow: 1;
  margin: auto 0;
  white-space: nowrap;
  overflow: hidden;
`;
const SUBTITLE_CSS = css `
  color: ${HEADER_SUBTITLE_COLOR};
  font-size: 90%;
`;
const TYPOGRAPHY_CSS = css `
  color: white;
  padding-left: 5px;
  user-select: none;
  cursor: pointer;
  &.MuiTypography-root {
    font-weight: bold;
    line-height: 1em;
  }
`;
export const HeaderTitle = ({ title, subTitle }) => {
    const dispatch = useAppDispatch();
    const onPointerDown = useCallback(() => {
        dispatch(setDrawerOpenState(true));
    }, [dispatch]);
    return (_jsx("div", { css: CONTAINER_CSS, children: (title || subTitle) && (_jsxs(Typography, { variant: 'subtitle1', onPointerDown: onPointerDown, css: TYPOGRAPHY_CSS, children: [_jsx("span", { "aria-label": 'title', children: title }), subTitle && _jsx("div", { css: SUBTITLE_CSS, children: subTitle })] })) }));
};
